import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const field = "h-12 w-full rounded-xl border border-white/10 bg-white/5 px-4 text-sm text-white outline-none focus:border-[#0066FF]";
  return (
    <div className="lt-grid-bg flex min-h-screen items-center justify-center bg-[#0A0B0E] px-4 text-white">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#12141A] p-8" data-testid="admin-login-form">
        <Logo tone="dark" />
        <h1 className="mt-8 font-display text-2xl font-semibold">Area amministrativa</h1>
        <p className="mt-1 text-sm text-slate-400">Accesso riservato</p>
        <div className="mt-8 space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="username" className={field} data-testid="admin-login-email" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" className={field} data-testid="admin-login-password" />
        </div>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-6 h-12 w-full rounded-full bg-[#0066FF] font-medium transition-colors hover:bg-[#1a75ff] disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? "Accesso…" : "Accedi"}
        </button>
        <Link to="/admin/password-dimenticata" className="mt-5 block text-center text-sm text-slate-400 hover:text-white" data-testid="admin-forgot-password-link">
          Password dimenticata?
        </Link>
      </form>
    </div>
  );
}
